__turbopack_context__.v({
  "content": "index-module-scss-module__y7zjRW__content",
  "languageSelector": "index-module-scss-module__y7zjRW__languageSelector",
  "svg": "index-module-scss-module__y7zjRW__svg",
});
